const CATEGORIES = [
  { id: 'all', label: 'All' },
  {
    id: 'ml-nlp',
    label: 'ML / NLP',
    keywords: [
      'pytorch',
      'hugging',
      'transformer',
      'qwen',
      't5',
      'bm25',
      'faiss',
      'numpy',
      'pandas',
      'scikit',
      'kilt',
      'hotpot',
      'natural questions',
      'transformer.js',
    ],
  },
  {
    id: 'llm-security',
    label: 'LLM Security',
    keywords: [
      'rag',
      'prompt injection',
      'trim',
      'llm-as-judge',
      'asr',
      'em / f1',
      'bootstrap',
      'cohen',
      'prompt engineering',
    ],
  },
  {
    id: 'frontend',
    label: 'Frontend',
    keywords: [
      'react',
      'vue',
      'next',
      'tailwind',
      'wasm',
      'web workers',
      'web speech',
      'readability',
      'wcag',
      'accessibility',
    ],
  },
  {
    id: 'backend',
    label: 'Backend & Infra',
    keywords: [
      'node',
      'microservice',
      'rest',
      'graphql',
      'mongo',
      'kafka',
      'elastic',
      'azure',
      'spring',
      'docker',
      'kubernetes',
      'java',
      'python',
      'javascript',
      'typescript',
      'sql',
      'postgresql',
      'mysql',
    ],
  },
  {
    id: 'tools',
    label: 'Tools',
    keywords: [
      'git',
      'linux',
      'pytest',
      'latex',
      'yaml',
      'jira',
      'agile',
    ],
  },
];

export { CATEGORIES };
